import axios from "axios";
import APIRoutes from "../../APIRoutes";

import { getAPIRoot } from "../../../utils/GeneralUtils";

/**
 * postUpdateTerm
 *
 * update term data.
 *
 * @param auth_token The user's auth token, used for fetching data that requires certain privileges
 * @param name Name of the term you wish to update.
 * @param id ID of the term you wish to update.
 * @param tax Tax id of the term you wish to update.
 * @param color Color of the term you wish to update.
 * @param img File of the term you wish to update.
 *
 * @returns Whether or not to update term.
 */

export const postUpdateTerm = async (
  auth_token: string,
  name?: string,
  id?: string,
  tax?: string,
  color?: string,
  img?: File
) => {
  const formData = new FormData();

  if (name !== undefined) {
    formData.append("sonic_name", name);
  }

  if (id) {
    formData.append("sonic_term_id", id);
  }

  if (tax) {
    formData.append("sonic_tax", tax);
  }

  if (color !== undefined) {
    formData.append("sonic_color", color);
  }

  if (img !== undefined) {
    formData.append("sonic_img", img, img.name);
  }

  try {
    const res = await axios.post(
      getAPIRoot(APIRoutes.post.term, "admin"),
      formData,
      {
        headers: {
          "X-Sonic-Auth": auth_token,
          "Content-Type": "multipart/form-data",
        },
      }
    );

    return res.data.result;
  } catch (e) {
    return false;
  }
};
